<template>
  <div :class="$style.container">
    <strong :class="$style.strong">{{content.subtitle}}</strong>
    <TextBlock
      :content="content.text"
      :title="content.title"/>
    <div :class="$style.firstRow">
      <div :class="$style.imgWrapper" v-lazy:background-image="content.first_image">
        <img v-lazy="content.first_image" :alt="content.subtitle"/>
      </div>
    </div>
    <!-- <div :class="$style.secondRow">
      <strong v-html="content.subtitle"></strong>
      <img v-lazy="content.second_image" :alt="content.subtitle"/>
    </div> -->
  </div>
</template>

<script>
import TextBlock from '@/components/TextBlock'

export default {
  props: ['content'],
  components: {
    TextBlock
  }
}
</script>

<style lang="scss" module>
@import "~sass-mq/mq";

.container {
  @include grid-size();
  position: relative;
  padding: $big-margin-mobile;
  padding-top: 0;

  @include mq(sm) {
    padding: $big-margin;
    padding-top: 0;
  }
}

.firstRow {
  display: block;
  text-align: right;
  margin: $standard-margin-mobile 0;

  @include mq(sm) {
    margin: $standard-margin 0;
  }

  .imgWrapper {
    position: relative;

    &:before {
      content: '';
      position: relative;
      display: block;
      width: 100%;
      padding-top: 46.52%;
    }

    background-size: cover;
  }

  img {
    @include visually-hidden;

    display: block;
    margin: 0 auto;
    width: 100%;

    @include mq(sm) {
      width: 100%;
      // max-width: 450px
    }
  }
}

.strong {
  display: inline-block;
  color: $color-charcoal;
  font-weight: 600;
  letter-spacing: 2.5px;
  font-size: font-size(s);
  margin-bottom: $small-margin;

  @include mq(sm) {
    position: absolute;
    right: 30px;
    top: 0;
  }

  @include mq(ds) {
    right: 80px;
  }
}

// .secondRow {

//   img {
//     padding-top: $big-margin;
//     display: block;
//     width: 100%;
//     max-width: 900px;
//   }

  
// }
</style>



// WEBPACK FOOTER //
// src/components/TechIntro.vue